var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovedIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#57A763;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.1,12.3c0-6.9,5.5-12.5,12.4-12.5s12.4,5.6,12.4,12.5c0,6.9-5.6,12.5-12.4,12.5S0.1,19.2,0.1,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.5,11.1h-0.8h-0.3v0.6h0.3c0.5,0,0.9,0.4,0.9,0.8c0,0.4-0.4,0.8-0.9,0.8H18h-0.2V14H18 c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8h-0.8h-0.1v0.6h0.1c0.5,0,0.9,0.4,0.9,0.8c0,0.4-0.4,0.8-0.9,0.8h-0.8H12 c-0.6,0-1.8-0.5-2.7-0.9c-0.9-0.4-1.4-0.6-1.8-0.6H4.7v-6.2c0.6,0,1.9,0,2.7,0c1.2,0,1.8-0.5,3.5-1.9c1.8-1.5,1.9-4.1,1.9-4.7 c0-0.3,0.4-0.4,0.6-0.4c0.3,0,1.1,0,1.1,1.7c0,2.1-1.1,4.2-1.1,4.3l-0.2,0.5h2.1h1.3h0.5c0,0,0,0,0,0h2.3c0.5,0,0.8,0.3,0.8,0.8 C20.4,10.7,20,11.1,19.5,11.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcn);
export default __webpack_public_path__ + "static/media/approved_icn.ef3d50354778b81b2d9161ee43f61236.svg";
export { ForwardRef as ReactComponent };